import React, { Component } from 'react';
import { Redirect } from 'react-router-dom';
import Recaptcha from 'react-recaptcha';

import './Register.css';

import { withStyles } from '@material-ui/core/styles';

import Button from '@material-ui/core/Button';
import CircularProgress from '@material-ui/core/CircularProgress';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';

import IconArrowBack from '@material-ui/icons/ArrowBack';
import IconPersonOutline from '@material-ui/icons/PersonOutline';
import IconEmail from '@material-ui/icons/Email';
import IconVpnKey from '@material-ui/icons/VpnKey';

import commonStyles from '../common/Styles';

import IconButtonLink from '../common/IconButtonLink';
import IcoTextField from '../common/IcoTextField';
// eslint-disable-next-line
const emailRegexp = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/;

const styles = (theme) => {
  const common = commonStyles(theme);
  return {
    header: {
      lineHeight: '32px',
      display: 'flex',
      '& > a': {
        marginTop: 4,
        marginBottom: 4,
        marginRight: 8,
        width: 24,
        height: 24,
        color: 'inherit',
      },
      '& > h2': {
        fontSize: 24,
        display: 'inline-block',
        fontWeight: 400,
        marginTop: 0,
        // marginBottom: 0,
      }
    },
    form: common.form,
    actionButtons: common.actionButtons,
    notes: {
      margin: 24,
      textAlign: 'left',
      fontWeight: 400,
      fontSize: 14,
      color: 'rgba(0, 0, 0, 0.87)',
      lineHeight: 1.5,
    },
    recaptcha: {
      margin: '32px 0 0 32px',
    },
  };
};

class Register extends Component {
  constructor(props) {
    super(props);
    this.state = {
      firstNameInvalid: true,
      lastNameInvalid: true,
      usernameInvalid: true,
      passwordInvalid: true,
      firstNameTouched: false,
      lastNameTouched: false,
      usernameTouched: false,
      passwordTouched: false,
      firstName: '',
      lastName: '',
      username: '',
      password: '',
      usernameError: '',
      passwordError: '',
      firstNameError: '',
      lastNameError: '',
      recaptchaVerified: false,
      showTerms: false,
    };
    this.handleBlur = (event) => {
      event.persist();
      const { target: { name }} = event;
      this.setState({  [`${name}Touched`]: true }, () => this.updateState(event));
    };
    this.updateState = ({ target: { name, value } }) => {
      this.setState({ [name]: value }, () => this.validate(name));
    };
    this.register = (event) => {
      const { username, password, firstName, lastName } = this.state;
      if (!this.valid() || this.state.inProgress) {
        return;
      }
      this.setState({ inProgress: true });
      event.preventDefault();
      window.AvaCAS.register({ username, password, firstName, lastName })
        .then(
          (data) => {
            this.setState({ afterCreate: true });
          },
          ({ response: { data: { errors: { children: { username: { errors = [''] } } } } } }) => {
            this.setState({
              inProgress: false,
              usernameTouched: true,
              usernameInvalid: true,
              usernameError: errors.length ? 'Username already used' : '',
            }, () => {
              // this.refs.username.focus();
            });
          }
        );
    };
    this.validate = (field = false) => {
      let { usernameInvalid, passwordInvalid, usernameTouched, passwordTouched } = this.state;
      let { firstNameInvalid, lastNameInvalid, firstNameTouched, lastNameTouched } = this.state;
      if (field === 'firstName' || !field) {
        firstNameInvalid = !this.state.firstName;
        const firstNameError = firstNameInvalid && firstNameTouched ? 'You must provide your First Name' : '';
        this.setState({ firstNameInvalid, firstNameError });
      }
      if (field === 'lastName' || !field) {
        lastNameInvalid = !this.state.lastName;
        const lastNameError = lastNameInvalid && lastNameTouched ? 'You must provide your Last Name' : '';
        this.setState({ lastNameInvalid, lastNameError });
      }
      if (field === 'password' || !field) {
        passwordInvalid = !this.state.password || (this.state.password || '').length < 8;
        const passwordError = passwordInvalid && passwordTouched ? 'Password must have at least 8 characters' : '';
        this.setState({ passwordInvalid, passwordError });
      }
      if (field === 'username' || !field) {
        usernameInvalid = !this.state.username || !emailRegexp.test(this.state.username);
        const usernameError = usernameInvalid && usernameTouched ? 'Username must be a valid e-mail address' : '';
        this.setState({ usernameInvalid, usernameError });
      }
      return !usernameInvalid && !passwordInvalid && !firstNameInvalid && !lastNameInvalid;
    };
    this.valid = () => {
      const { firstNameInvalid, lastNameInvalid, usernameInvalid, passwordInvalid, recaptchaVerified } = this.state;
      return !usernameInvalid && !passwordInvalid && !firstNameInvalid && !lastNameInvalid && recaptchaVerified;
    };

    this.verifyRecaptcha = () => {
      this.setState({ recaptchaVerified: true });
    };

    this.showTerms = () => {
      this.setState({ showTerms: true });
    };

    this.handleCloseTerms = () => {
      this.setState({ showTerms: false });
    };
  }
  componentDidMount() {
    this.validate();
  }
  render() {
    const { classes } = this.props;
    const { afterCreate } = this.state;
    if (afterCreate) {
      return ( <Redirect to="/welcome" push={true} /> );
    }
    return (
      <div>
        <form
          className={classes.form}>
          <div
            className={classes.header}>
            <IconButtonLink
              to="/"><IconArrowBack /></IconButtonLink>
            <h2>Create new account</h2>
          </div>
          <IcoTextField
            autoFocus
            icon={IconPersonOutline}
            required
            id="firstName"
            name="firstName"
            label="First Name"
            type="text"
            value={this.state.firstName}
            margin="normal"
            helperText={this.state.firstNameError}
            onBlur={this.handleBlur}
            onChange={this.updateState}
            error={!this.state.firstName && this.state.firstNameInvalid && this.state.firstNameTouched}
            onKeyDown={(event) => event.key === 'Enter' ? this.register(event) : null }></IcoTextField>
          <IcoTextField
            icon={IconPersonOutline}
            required
            id="lastName"
            name="lastName"
            label="Last Name"
            type="text"
            value={this.state.lastName}
            margin="normal"
            helperText={this.state.lastNameError}
            onBlur={this.handleBlur}
            onChange={this.updateState}
            error={!this.state.lastName && this.state.lastNameInvalid && this.state.lastNameTouched}
            onKeyDown={(event) => event.key === 'Enter' ? this.register(event) : null }></IcoTextField>
          <IcoTextField
            icon={IconEmail}
            ref="username"
            required
            id="username"
            name="username"
            label="E-mail (your username)"
            value={this.state.username}
            type="email"
            margin="normal"
            helperText={this.state.usernameError}
            onBlur={this.handleBlur}
            onChange={this.updateState}
            error={this.state.usernameInvalid && this.state.usernameTouched}
            onKeyDown={(event) => event.key === 'Enter' ? this.register(event) : null }></IcoTextField>
          <IcoTextField
            icon={IconVpnKey}
            required
            id="password"
            name="password"
            label="Password"
            type="password"
            value={this.state.password}
            margin="normal"
            helperText={this.state.passwordError}
            onBlur={this.handleBlur}
            onChange={this.updateState}
            error={this.state.passwordInvalid && this.state.passwordTouched}
            onKeyDown={(event) => event.key === 'Enter' ? this.register(event) : null }></IcoTextField>
          <div
            className={classes.recaptcha}>
            <Recaptcha
              sitekey={this.props.captchaKey || process.env.REACT_APP_RECAPTCHA_SITEKEY || ''}
              render="explicit"
              verifyCallback={this.verifyRecaptcha} />
          </div>
          <div
            className={classes.notes}>
              <span>
                  {this.props.termsShort}&nbsp;
                  By clicking Continue, you agree to the {this.props.instanceName} <span className="terms-link" onClick={this.showTerms}>Terms of Service, Privacy Policy</span> and the use of cookies.</span>
          </div>
          <Dialog
            open={this.state.showTerms}
            onClose={this.handleCloseTerms}
            onBackdropClick={this.handleCloseTerms}
            fullWidth={true}
            maxWidth="md"
          >
            <DialogTitle>{'Terms of Service'}</DialogTitle>
            <DialogContent>
              <DialogContentText >
                <div dangerouslySetInnerHTML={{__html: this.props.termsLong}}></div>
              </DialogContentText>
            </DialogContent>
            <DialogActions>
              <Button onClick={this.handleCloseTerms} color="primary">
                Close
              </Button>
            </DialogActions>
          </Dialog>
          <div
            className={classes.actionButtons}>
            <span className="to-right">
              { this.state.inProgress && <CircularProgress className="in-progress" size={32} /> }
              <Button
                color="secondary"
                variant="contained"
                disabled={!this.valid() || this.state.inProgress}
                onClick={this.register}>Continue</Button>
            </span>
          </div>
        </form>
      </div>
    );
  }
}

export default withStyles(styles)(Register)



// WEBPACK FOOTER //
// ./src/components/Register/index.js